import {
	createTheme,
} from '@mui/material'

import {
	materialUIBreakpointsTheme,
} from './material-ui-breakpoints.theme'

export const materialUICommonTheme = createTheme({
	typography: {
		fontFamily: 'var(--font-family-base), "sans-serif"',
	},

	breakpoints: materialUIBreakpointsTheme,

	components:  {
		MuiStack: {
			defaultProps: {
				useFlexGap: true,
			},
		},
		MuiTypography: {
			defaultProps: {
				fontFamily: 'var(--font-family-base)',
			},
		},
	},

	spacing: (factor: number) => {
		return `var(--base-spacing-${String(factor)})`
	},
})
